import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import { WorkshopCardProps } from '../types';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import useFetchWithAuth from '../../../../CommonHooks/useFetchWithAuth';
import { errorToast } from '../../../../CommonComponent/toast';
import { happeningBaseUrl } from '../../../../baseUrl';
import { HappeningType } from '../../../../globalContant';
import { noop } from 'lodash';
import { asyncNoop } from '../../../../util';

interface WorkshopContextType {
  workshopList: WorkshopCardProps[];
  setWorkshopList: React.Dispatch<React.SetStateAction<WorkshopCardProps[]>>;
  setSelectedWorkshop: React.Dispatch<React.SetStateAction<WorkshopCardProps>>;
  selectedWorkshop: WorkshopCardProps;
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  files: File[];
  setOldFiles: React.Dispatch<React.SetStateAction<string[]>>;
  oldFiles: string[];
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  getAllWorkshops: () => Promise<void>;
  setIsNew: React.Dispatch<React.SetStateAction<boolean>>;
  isNew: boolean;
}

const intialData: WorkshopContextType = {
  workshopList: [],
  setWorkshopList: noop,
  setSelectedWorkshop: noop,
  selectedWorkshop: {
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  },
  setFiles: noop,
  files: [],
  isLoading: false,
  setIsLoading: noop,
  getAllWorkshops: asyncNoop,
  setOldFiles: noop,
  oldFiles: [],
  setIsNew: noop,
  isNew: false,
};

const WorkshopContext = createContext<WorkshopContextType>(intialData);
const WorkshopProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isNew, setIsNew] = useState<boolean>(false);
  const [workshopList, setWorkshopList] = useState<WorkshopCardProps[]>([]);
  const [files, setFiles] = useState<File[]>([]);
  const [oldFiles, setOldFiles] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { instituteId } = useMainContainerProvider();
  const { fetchWithAuth } = useFetchWithAuth();
  const [selectedWorkshop, setSelectedWorkshop] = useState<WorkshopCardProps>({
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  });

  const getAllWorkshops = async () => {
    setIsLoading(true);
    const { error, data } = await fetchWithAuth(`get-happening/?type=${HappeningType.WORKSHOP}&instituteId=${instituteId}`, {}, happeningBaseUrl);
    setIsLoading(false);
    if (error) {
      errorToast(error);
    } else {
      const updatedResult = data?.result.map((item: WorkshopCardProps) => {
        return {
          ...item,
          interactions: typeof item.interactions === 'string' ? JSON.parse(item.interactions) : item.interactions,
        };
      });
      setWorkshopList(updatedResult ? updatedResult : []);
    }
    // eslint-disable-next-line
  };

  useEffect(() => {
    if (!workshopList.length) {
      getAllWorkshops();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <WorkshopContext.Provider
      value={{
        workshopList,
        setWorkshopList,
        setSelectedWorkshop,
        selectedWorkshop,
        setFiles,
        files,
        isLoading,
        setIsLoading,
        getAllWorkshops,
        setOldFiles,
        oldFiles,
        isNew,
        setIsNew,
      }}
    >
      {children}
    </WorkshopContext.Provider>
  );
};

export default WorkshopProvider;

export const useWorkshopProvider = () => useContext(WorkshopContext);
